export default (
  graphId,
  surveyId,
  features,
  updateGraphMutation,
  viewToken
) => {
  if (graphId && surveyId && features && updateGraphMutation) {
    const updatedFeatures = features.map(iF => {
      const innerFeature = iF;

      delete innerFeature.__typename;
      delete innerFeature.id;

      if (innerFeature.featureIndex || innerFeature.featureIndex === 0) {
        delete innerFeature.featureIndex;
      }
      return innerFeature;
    });

    updateGraphMutation({
      variables: {
        id: graphId,
        survey: surveyId,
        features: updatedFeatures,
        ...(viewToken ? { viewToken } : {})
      }
    });
  }
};
